export const numericOrder = (num1: number, num2: number) => {
  return num1 - num2;
};

export const alphabeticalOrder = (string1: string, string2: string) => {
  return string1.localeCompare(string2);
};
